import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // Liste von URLs, die vom Interceptor ausgeschlossen werden
  private readonly excludedUrls = ['https://api.goclimate.com'];

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const isExcluded = this.excludedUrls.some((url) => req.url.startsWith(url));

    if (isExcluded) {
      // Für ausgeschlossene URLs die Anfrage unverändert weiterleiten
      // Hier wird der manuell gesetzte 'Authorization: Basic ...' Header nicht überschrieben
      return next.handle(req);
    }

    // Deprecated JWT authentication - commented out for potential future reintegration.
    // For the moment, we decided to only user Switch-Authentication
    // for the first version at least.
    // const token = this.authService.getToken();
    // if (token) {
    //   req = req.clone({
    //     setHeaders: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });
    // }

    // // For requests sent after logging in with oidc
    if (this.authService.activeUser$) {
      req = req.clone({ withCredentials: true });
    }

    return next.handle(req);
  }
}
